export const DEFAULT_BACKSHIP_SHIPPER = {
  id: 33,
  shipper_name: 'BackShip - DHL Express',
}
